export default "__VITE_ASSET__fc32461a__"